import {
  GET_PRODUCT_CATEGORY_LIST_RESPONSE,
  ADD_PRODUCT_CATEGORY_RESPONSE,
  UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE,
  UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_RESPONSE,
  DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  productCategoryApiResponse: null,
  productCategoryData: [],
  productCategoryList: [],
  productCategoryRecord: null,
};

const productCategoryMaster = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_PRODUCT_CATEGORY_LIST_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.productCategoryData = response.responseData;
        } else {
          draft.productCategoryData = [];
        }
        break;

      case ADD_PRODUCT_CATEGORY_RESPONSE:
        draft.productCategoryApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE:
        draft.productCategoryApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_RESPONSE:
        draft.productCategoryApiResponse = action.payload.apiResponse;
        break;

      case DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE:
        draft.productCategoryApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default productCategoryMaster;
